import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import { ReduxState } from '../store/state';
import { BusinessItem, ItemsQuery } from '../store/page/types';
import { asyncGetSoldOutEstimate, fetchPage } from '../store/page/initiators';
import { updateItemsQuery, getQueriedItemsSuccess } from '../store/page/actions';
import LoadingPage from './loading/LoadingPage';
import NotFoundPage from './error/NotFoundPage';
import DefaultThemePage from './themes/DefaultThemePage';
import NavBar from '../components/navigation/NavBar';
import Footer from '../components/navigation/Footer';
import { Box } from '@chakra-ui/layout';

interface LandingPageProps {
  selectedPage: BusinessItem | null;
  loading: boolean;
  itemsQuery: ItemsQuery;
  fetchPage: (pageKey: string, newFetch?: boolean) => void;
  asyncGetSoldOutEstimate: (itemId: string) => void;
  updateItemsQuery: (update: ItemsQuery) => void;
  getQueriedItemsSuccess: (items: BusinessItem[]) => void;
}

const LandingPage: React.FC<LandingPageProps> = ({ 
  selectedPage, loading, itemsQuery,
  fetchPage,
  asyncGetSoldOutEstimate,
  updateItemsQuery,
  getQueriedItemsSuccess
 }) => {
  const { pageKey } = useParams();

  // useEffect(() => {
  //   if (pageKey) {
  //     fetchPage(pageKey, true);
  //     updateItemsQuery({...itemsQuery, search: ''});
  //     getQueriedItemsSuccess([]);
  //   }

  //   // Start polling for updates every 30 seconds and push page update
  //   const intervalId = setInterval(() => {
  //     if (pageKey) {
  //       fetchPage(pageKey);
  //       if (selectedPage) {
  //         asyncGetSoldOutEstimate(selectedPage._id);
  //       }
  //     }
  //   }, 30000);

  //   // Clean up the interval on component unmount
  //   return () => clearInterval(intervalId);
  // }, [pageKey]);

  useEffect(() => {
    if (pageKey) {
      // Redirect to the external URL with the pageKey
      window.location.href = `https://www.goshowfa.com/p/${pageKey}`;
    }
  }, [pageKey]);

  if (loading && !selectedPage) {
    return (
      <>
        {/* <NavBar  />
        <LoadingPage /> */}
      </>
    )
  } else if (!loading && selectedPage && selectedPage.pageData) {
    // add other themes then fallback to default
    if (selectedPage.pageData.pageTheme === 'default') {
      return (
        <Box bg={'gray.50'}>
          {/* <NavBar  /> */}
          {/* <DefaultThemePage /> */}
          {/* <Footer /> */}
        </Box>
      
      )
    }
  }
  return <NotFoundPage />
};

const mapStateToProps = (state: ReduxState) => {
  const { selectedPage, loading, itemsQuery } = state.page;
  return { selectedPage, loading, itemsQuery };
};

export default connect(mapStateToProps, {
  fetchPage,
  asyncGetSoldOutEstimate,
  updateItemsQuery,
  getQueriedItemsSuccess
})(LandingPage);